import { AnnotationsIntegrationSelectionState } from '../components/annotations/components/indicators/types.js';

export const buildSelectionData = (
  markerKey: string,
): AnnotationsIntegrationSelectionState => ({
  data: [
    {
      markers: [
        {
          title: 'Marked for termination',
          description: 'AuthenticationService',
          symbol: 'T',
          start: new Date('2022-04-05T12:18:00.000Z'),
          color:
            'var(--dt-colors-charts-categorical-themed-blue-steel-color-05-default, #638ecf)',
          indicatorsDisplay: 'auto',
          id: 'bec7cf0d-98b7-40c2-adfd-30714b89607a',
          priority: 0,
          hidden: false,
        },
      ],
      priority: 0,
      key: '1649161080000_1649161080000',
    },
  ],
  hoveredGroup: markerKey,
  hoveredItem: markerKey,
  hoveredListItem: '2a77887d-596c-4842-97be-497f99db1c46',
  pinnedGroup: markerKey,
});
